<template>
  <div class="TcInscriptionConfirm inline-block bg-white rounded-xl text-left overflow-hidden shadow-xl transform transition-all align-middle max-w-4xl w-full px-5">
    <div class="py-10">
      <div class="flex flex-col items-center">
        <div class="mx-auto flex-shrink-0 flex items-center justify-center rounded-full bg-green-400 text-white">
          <TcIcon icon="thumb-up" class="h-16 w-16 text-white m-3"></TcIcon>
        </div>
        <p class="my-5 text-3xl text-center">Resumen de la preinscripción</p>
          <div v-if="questions && questions.length" class="w-7/12 bg-white p-5 mt-3 shadow-lg text-left">
            <h4 class="font-semibold mb-3">Preguntas del evento</h4>
            <div v-for="(question, index) in questions" :key="index" class="mb-2">
              <span class="font-medium">{{ question.name }}:</span>
              <span>{{ question.value }}</span>
            </div>
          </div>
          <div class="w-7/12 bg-gray-100 p-5 mt-3 shadow-lg">
          <table class="w-full">
            <thead>
              <tr>
                <th>Concepto</th>
                <th>Cantidad</th>
                <th>Subtotal</th>
              </tr>
            </thead>
            <tbody class="w-full">
              <tr class="colegiado">
                  <td>
                      <div>Colegiado</div>
                  </td>
                  <td>1</td>
                  <td class="price">{{ event.amount.strToEuro() }}</td>
              </tr>
              <tr v-if="companions" class="companions">
                  <td>
                      <div>Acompañante</div>
                  </td>
                  <td>{{companions.amount}}</td>
                  <td class="price">{{numberToEur(companions.amount * companions.unit_price)}}</td>
              </tr>
              <tr v-if="guests" class="guests">
                  <td>
                      <div>Invitado adulto</div>
                  </td>
                  <td>{{guests.amount}}</td>
                  <td class="price">{{numberToEur(guests.amount * guests.unit_price)}}</td>
              </tr>
              <tr v-if="children" class="children">
                  <td>
                      <div>Invitado menor</div>
                  </td>
                  <td>{{children.amount}}</td>
                  <td class="price">{{numberToEur(children.amount * children.unit_price)}}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="total">
                <td colspan="2">TOTAL A PAGAR:</td>
                <td>{{ numberToEur(total) }}</td>
              </tr>
            </tfoot>
          </table>
          <div v-if="total != 0" class="flex justify-center items-center gap-3 p-3 bg-red-300">
            <TcIcon icon="exclamation" class="w-28 text-red-600"></TcIcon>
            <input id="paymentInfoCheck" type="checkbox" v-model="checked" class="h-20 w-20">
            <label for="paymentInfoCheck">Acepto que realizaré el <b>pago en ventanilla</b> de este Colegio en el plazo de una hora para validar mi inscripción.</label>
          </div>
          <div v-else class="flex justify-center items-center gap-3 p-3 bg-red-300">
            <TcIcon icon="exclamation" class="w-10 text-red-600"></TcIcon>
            <input id="paymentInfoCheck" type="checkbox" v-model="checked" class="h-8 w-8">
            <label for="paymentInfoCheck">Acepto las condiciones del evento.</label>
          </div>
        </div>
        <div class="flex w-full justify-center mt-10 gap-3">
          <button class="w-full max-w-sm btn-secondary text-lg p-3" @click="$parent.setState(null)">Modificar datos</button>
          <button class="w-full max-w-sm bg-green-400 text-lg p-3"
            :disabled="!checked"
            @click="$parent.postEvent">
            Confirmar preinscripción</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  table thead tr th:nth-child(2), table tbody tr td:nth-child(2) {
    text-align: center;
  }
  table thead tr th:nth-child(3), table tbody tr td:nth-child(3) {
    text-align: right;
  }
  table thead tr th {
    font-weight: bold;
    border-bottom: 4px solid #888;
  }
  table tbody tr td {
    padding: 1rem 0;
  }
  table tbody tr td {
    border-bottom: 1px solid #888;
  }
  table tfoot tr td {
    text-align: right;
    padding: .5rem 0;
  }
  td.price {
    text-align: right;
  }
  tr.total td {
    border-top: 4px solid #888;
    font-size: 110%;
    font-weight: bold;
  }
</style>

<script>
import TcIcon from './TcIcon.vue'

export default {
  name: 'TcInscriptionConfirm',
  components: {
    TcIcon,
  },
  props: [
    'event',
    'companions',
    'guests',
    'children',
    'questions',
    'igic',
  ],
  data () {
    return {
      checked: false,
    }
  },
  computed: {
    base: function() {
      if(!this.event) return 0
      let base = parseFloat(this.event.amount);

      if(this.companions)
        base += this.companions.amount ?
          this.companions.amount * this.companions.unit_price : 0;

      if(this.guests)
        base += this.guests.amount ?
          this.guests.amount * this.guests.unit_price : 0;

      if(this.children)
        base += this.children.amount ?
          this.children.amount * this.children.unit_price : 0;

      return base
    },
    total: function() {
      return this.base;
    },
  },
  methods: {
    numberToEur: function (number) {
      if(number!= undefined)
        return number.toLocaleString('es-ES', {style: 'currency', currency: 'EUR'})
      return ''
    }
  },
}
</script>
